export default __webpack_public_path__ + "static/media/2-min.f8c6fd5f.jpg";